import React from 'react';
import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';
import Popper from '@material-ui/core/Popper';
import { Panel, block } from 'searchkit';

/* eslint-disable jsx-a11y/click-events-have-key-events */
class PanelWithClickOutsideBase extends Panel {
  constructor(props) {
    super(props);

    this.titleRef = React.createRef();

    this.binded = {
      toggleCollapsed: this.toggleCollapsed.bind(this),
    };
  }

  componentWillUnmount() {
    this.titleRef.current = null;
  }

  renderTitle() {
    const { title, mod, collapsable, disabled } = this.props;
    const containerBlock = block(mod).state({ disabled });
    const collapsed = collapsable && this.state.collapsed;

    if (collapsable && !disabled) {
      return (
        <div
          ref={this.titleRef}
          role="button"
          className={containerBlock.el('header').state({ collapsable, collapsed })}
          onClick={this.binded.toggleCollapsed}
          tabIndex={0}
        >
          {title}
        </div>
      );
    }

    return (
      <div className={containerBlock.el('header').state({ collapsable, collapsed })}>{title}</div>
    );
  }

  renderClearButton() {
    const { mod, disabled, hasSelection } = this.props;
    const containerBlock = block(mod).state({ disabled });

    if (hasSelection) {
      return (
        <button
          className={containerBlock.el('clear')}
          title="Clear filter"
          onClick={this.props.clear}
        >
          <span className={containerBlock.el('clear-icon')} />
        </button>
      );
    }

    return null;
  }

  renderContent() {
    const { mod, collapsable, disabled, children, title } = this.props;
    const containerBlock = block(mod).state({ disabled });
    const collapsed = collapsable && this.state.collapsed;

    if (!disabled) {
      return (
        <Popper
          id={`popper-${title}`}
          open={!!this.titleRef?.current}
          anchorEl={this.titleRef?.current}
          placement="bottom-start"
          className={containerBlock.el('content').state({ collapsed })}
          disablePortal
        >
          {children}
        </Popper>
      );
    }

    return null;
  }

  render() {
    const { mod, className, disabled } = this.props;
    const containerBlock = block(mod).state({ disabled });

    return (
      <div className={containerBlock.mix(className)}>
        {this.renderTitle()}
        {this.renderClearButton()}
        {this.renderContent()}
      </div>
    );
  }

  handleClickOutside() {
    this.setState({
      collapsed: true,
    });
  }
}

const PanelWithClickOutside = onClickOutside(PanelWithClickOutsideBase);

class PanelOuterClick extends React.Component {
  static propTypes = {
    hasSelection: PropTypes.bool,
  };

  static defaultProps = {
    hasSelection: false,
  };

  render() {
    return (
      <PanelWithClickOutside
        {...this.props}
        className={this.props.hasSelection ? 'has-selection' : ''}
      />
    );
  }
}

export default PanelOuterClick;
